import { Address } from '@31third/common';
import { SellEntry } from '../model';
import { RebalancingAmountEntryDto } from '../dto';

export class RebalancingAmountEntryFactory {
  public static createAmountEntryFromSellEntry(
    sellEntry: SellEntry,
  ): RebalancingAmountEntryDto {
    return this.createAmountEntry(
      sellEntry.asset.token.address,
      sellEntry.getAmountInTokenUnits().toString(),
    );
  }

  public static createAmountEntry(
    tokenAddress: Address,
    amount: string,
  ): RebalancingAmountEntryDto {
    const baseEntry = new RebalancingAmountEntryDto();
    baseEntry.amount = amount;
    baseEntry.tokenAddress = tokenAddress;
    return baseEntry;
  }
}
